import { Fragment, useState } from "react";
import Dropdown from "../../accessories/DropDown";
import {
  IconButton,
  InputBox,
  Option,
  Title,
} from "../../accessories/accessories";
import { Dimensions, ScrollView, View } from "react-native";
import CustomText from "../../accessories/CustomText";
import {
  FormatPhoneLogin,
  handleAPI,
  handleGetZipCodeDetails,
} from "../../accessories/CommonFunctions";
import { web } from "../../accessories/Platform";
import ScrollContainer from "../../accessories/ScrollContainer";

const OtherLoanVendor = ({
  stateOptions,
  drawerDetails,
  onClose,
  loanId,
  bankIndex,
  handlePostVendorAdd,
  SessionId: SessionID,
}) => {
  const [vendorType, setVendorType] = useState(null);

  //type ==> 1 - text, 2 - CellPhone, 3 - DropDown, 4 - Zip
  const [otherLoanVendorDetails, setOtherLoanVendorDetails] = useState({
    1: [
      { name: "AgentID", value: 0 },
      { name: "ContactSourceType", value: "S" },
      { name: "ContactType", value: 0 },
      { name: "ContactTypename", value: "Seller" },
      { name: "IsModified", value: 1 },
      { name: "IsNew", value: 0 },
      { name: "Loanid", value: loanId },
      { name: "VendorId", value: 0 },
      { name: "isCard", value: 1 },
      { name: "tempAgentID", value: 0 },

      {
        name: "FirstName",
        label: "First Name",
        type: 1,
        value: "",
      },
      {
        name: "LastName",
        label: "Last Name",
        type: 1,
        value: "",
      },
      {
        name: "Companyname",
        label: "Entity Name",
        type: 1,
        value: "",
      },
      {
        name: "Phone",
        label: "Cell Phone",
        type: 2,
        value: "",
      },
      {
        name: "AgentEmail",
        label: "Email",
        type: 1,
        value: "",
      },
      {
        name: "CompanyStreetAddr",
        label: "Seller Street Address",
        type: 1,
        value: "",
      },
      {
        name: "CompanyZip",
        label: "Zip Code",
        type: 4,
        value: "",
      },
      {
        name: "CompanyCity",
        label: "City",
        type: 1,
        value: "",
      },
      {
        name: "CompanyState",
        label: "State",
        type: 3,
        value: "",
      },
    ],
    2: [
      { name: "ContactType", value: 4 },
      { name: "ContactTypename", value: "Escrow (for borrower)" },
      { name: "IsModified", value: 1 },
      { name: "IsNew", value: 1 },
      { name: "Loanid", value: loanId },
      { name: "iNoRealtorReprestation", value: 0 },
      { name: "isCard", value: 1 },
      {
        name: "Companyname",
        label: "Company Name",
        type: 1,
        value: "",
      },
      {
        name: "FirstName",
        // label: "Agent First Name",
        type: 1,
        value: "",
      },
      {
        name: "LastName",
        // label: "Agent Last Name",
        type: 1,
        value: "",
      },
      {
        name: "Phone",
        // label: "Agent Cell Phone",
        type: 2,
        value: "",
      },
      {
        name: "AgentEmail",
        // label: "Agent Email",
        type: 1,
        value: "",
      },
      {
        name: "AgentLicense",
        // label: "Agent License Number",
        type: 1,
        value: "",
      },
      {
        name: "CompanyStreetAddr",
        label: "Company Street Address",
        type: 1,
        value: "",
      },
      {
        name: "CompanyZip",
        label: "Company Zip Code",
        type: 4,
        value: "",
      },
      {
        name: "CompanyCity",
        label: "Company City",
        type: 1,
        value: "",
      },
      {
        name: "CompanyState",
        label: "Company State",
        type: 3,
        value: "",
      },
      {
        name: "CompPhone",
        label: "Company Phone",
        type: 2,
        value: "",
      },

      {
        name: "CompanyLicense",
        // label: "Company License Number",
        type: 1,
        value: "",
      },
      {
        name: "FileNumber",
        // label: "File Number",
        type: 1,
        value: "",
      },
    ],
    3: [
      { name: "ContactType", value: 50 },
      { name: "Loanid", value: loanId },
      { name: "IsModified", value: 1 },
      { name: "IsNew", value: 1 },
      { name: "iNoRealtorReprestation", value: 0 },
      { name: "isCard", value: 1 },
      { name: "ContactTypename", value: "Realtor (for borrower)" },

      {
        name: "Companyname",
        label: "Company Name",
        type: 1,
        value: "",
      },
      {
        name: "FirstName",
        //  label: "Agent First Name",
        type: 1,
        value: "",
      },
      {
        name: "LastName",
        //  label: "Agent Last Name",
        type: 1,
        value: "",
      },
      {
        name: "Phone",
        //   label: "Agent Cell Phone",
        type: 2,
        value: "",
      },
      {
        name: "AgentEmail",
        //   label: "Agent Email",
        type: 1,
        value: "",
      },
      {
        name: "AgentLicense",
        //    label: "Agent License Number",
        type: 1,
        value: "",
      },
      {
        name: "CompanyStreetAddr",
        label: "Company Street Address",
        type: 1,
        value: "",
      },
      {
        name: "CompanyZip",
        label: "Company Zip Code",
        type: 4,
        value: "",
      },
      {
        name: "CompanyCity",
        label: "Company City",
        type: 1,
        value: "",
      },
      {
        name: "CompanyState",
        label: "Company State",
        type: 3,
        value: "",
      },
      {
        name: "CompPhone",
        label: "Company Phone",
        type: 2,
        value: "",
      },
      {
        name: "CompanyLicense",
        // label: "Company License Number",
        type: 1,
        value: "",
      },
    ],
  });

  const handleOnchange = ({ text, index }) => {
    setOtherLoanVendorDetails((prevOtherLoanVendorDetails) => {
      prevOtherLoanVendorDetails[vendorType][index]["value"] = text;
      return { ...prevOtherLoanVendorDetails };
    });
  };

  const handleValidation = () => {
    return (
      otherLoanVendorDetails[vendorType].filter(({ label, value, type }) => {
        let isValid = label && !value;
        if ([2, 4].includes(type) && value) {
          isValid = !(
            value
              .replaceAll("(", "")
              .replaceAll(")", "")
              .replaceAll(" ", "")
              .replaceAll("-", "").length ==
            (type == 2 ? 10 : type == 4 ? 5 : 0)
          );
        }
        return isValid || false;
      }).length > 0
    );
  };
  return (
    <>
      <Title text="Add New Vendor" style={{ textAlign: "center" }} />
      <View
        style={{
          maxHeight: web ? 600 : Dimensions.get("window").height / 2 - 30,
          minHeight: web ? 600 : Dimensions.get("window").height / 2 - 30,
          flex: 1,
        }}
      >
        <ScrollView>
          <View style={{ paddingHorizontal: web ? 15 : 10 }}>
            <View>
              <CustomText style={{ fontSize: 20, marginBottom: 25 }}>
                Is your Earnest Money deposit held by the{" "}
                <CustomText bold={true}>Realtor</CustomText>, an{" "}
                <CustomText bold={true}>Escrow Company</CustomText>, or the{" "}
                <CustomText bold={true}>Seller</CustomText> ?
              </CustomText>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                }}
              >
                {[
                  { value: 1, text: "Seller" },
                  { value: 2, text: "Escrow" },
                  { value: 3, text: "Realtor" },
                ]?.map(({ text, value }, iIndex) => (
                  <Option
                    key={iIndex}
                    style={{ width: web ? "23%" : "30%" }}
                    text={text}
                    value={value == vendorType}
                    textStyle={{ fontSize: 13 }}
                    iconSize={15}
                    onPress={() =>
                      setVendorType(value == vendorType ? null : value)
                    }
                  />
                ))}
              </View>
            </View>
            {vendorType && (
              <>
                {otherLoanVendorDetails[vendorType].map(
                  ({ name, label, type, value, Options = [] }, index) => {
                    return (
                      <Fragment key={index}>
                        {label ? (
                          <>
                            {[1, 2, 4].includes(type) ? (
                              <InputBox
                                label={label}
                                keyboardType={
                                  [2, 4].includes(type) ? "numeric" : "default"
                                }
                                maxLength={
                                  type == 2 //Phone
                                    ? 10
                                    : type == 4 //Zip
                                    ? 5
                                    : 1000
                                }
                                placeholder={label}
                                onBlur={async () => {
                                  if (type == 4) {
                                    let zipCode = value;
                                    if (zipCode.length === 5) {
                                      let { city, state } =
                                        await handleGetZipCodeDetails(zipCode);
                                      setOtherLoanVendorDetails(
                                        (prevOtherLoanVendorDetails) => {
                                          prevOtherLoanVendorDetails[
                                            vendorType
                                          ][index + 1]["value"] = city;
                                          prevOtherLoanVendorDetails[
                                            vendorType
                                          ][index + 2]["value"] = state;
                                          return {
                                            ...prevOtherLoanVendorDetails,
                                          };
                                        }
                                      );
                                    }
                                  } else if (type == 2) {
                                    setOtherLoanVendorDetails(
                                      (prevOtherLoanVendorDetails) => {
                                        prevOtherLoanVendorDetails[vendorType][
                                          index
                                        ]["value"] = FormatPhoneLogin(
                                          value || ""
                                        );

                                        return {
                                          ...prevOtherLoanVendorDetails,
                                        };
                                      }
                                    );
                                  }
                                }}
                                onChangeText={(text) => {
                                  handleOnchange({ text, index });
                                }}
                                value={value?.toString()}
                                validate={!value}
                              />
                            ) : type === 3 ? (
                              <Dropdown
                                isValid={!Number(value)}
                                label={label}
                                options={stateOptions}
                                value={value}
                                onSelect={({ value }) => {
                                  handleOnchange({ text: value, index });
                                }}
                                isMap={true}
                              />
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Fragment>
                    );
                  }
                )}
              </>
            )}
          </View>
        </ScrollView>
      </View>
      {vendorType && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-end",
            marginVertical: 10,
          }}
        >
          <IconButton
            buttonType="secondary"
            style={{
              marginRight: 10,
              paddingVertical: 7,
              paddingHorizontal: 10,
            }}
            onPress={onClose}
            title={
              <CustomText
                bold={true}
                style={{ fontSize: 16, color: "#508BC9" }}
              >
                Close
              </CustomText>
            }
          />
          <IconButton
            disable={handleValidation()}
            style={{
              marginRight: 10,
              paddingVertical: 7,
              paddingHorizontal: 10,
            }}
            onPress={() => {
              const SaveJson = {};
              otherLoanVendorDetails[vendorType].forEach(({ name, value }) => {
                SaveJson[name] = value;
              });
              // console["log"](SaveJson);

              // return;

              handleAPI({
                apiName: "VendorAPI",
                name: "Save_VendorLoanInfo_API", //"Save_VendorLoanInfo",
                params: {
                  SessionID,
                  SaveJson: JSON["stringify"]([SaveJson])
                    .replaceAll("#", "|H|")
                    .replaceAll("&", "|A|"),
                },
                method: "POST",
              }).then((response) => {
                const { VendorId } = JSON.parse(response)[0];
                handlePostVendorAdd({
                  LoanID: loanId,
                  bankIndex,

                  VendorId,
                });
                onClose();
              });
            }}
            title={
              <CustomText bold={true} style={{ fontSize: 16, color: "#fff" }}>
                Save
              </CustomText>
            }
          />
        </View>
      )}
    </>
  );
};

export default OtherLoanVendor;
